import Link from 'next/link';
import * as React from 'react';
import { useUserPlan } from '../auth/plans/useUserPlan';



type Props = {
  children: React.ReactNode
}


const ChannelRecommenderLink = ({ children }: Props) => {
  const plan = useUserPlan()
  const isSubscribed = plan?.plan === 'SUBSCRIBED';

  let url = '/channel-recommender-preview';

  if (isSubscribed) {
    url = '/channel-recommender';
  }

  return (
    <Link href={url}>
      {children}
    </Link>
  );
};

export default ChannelRecommenderLink;